import React, { useEffect, useState, useRef } from "react";
import swal from "sweetalert";
import {
  Col,
  Card,
  Table,
  Dropdown,
  Modal,
 
  Alert,
  Spinner,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Baseurl from "../../../Baseurl";
import axios from "axios";
import { useHistory } from "react-router-dom";
function Cashback() {
  var history = useHistory();
 
  const data = document.querySelectorAll("#job_data tbody tr");
  const sort = 10;
  const activePag = useRef(0);
  const [heading, setHeading] = useState("");
  const [amount, setAmount] = useState("");
  const [orderLimit, setOrderLimit] = useState("");
  const [userOrderLimit, setUserOrderLimit] = useState("");
  const [allCashBack, setAllCashBack] = useState("");
  const [updateStatus, setUpdateStatus] = useState(false);
  const [cashBackId, setCashBackId] = useState(false);

  const [searchData, setSearchData] = useState([]);
  const handleClose = () => setShow(false);
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [spinner, setSpinner] = useState(true);
  const [test, settest] = useState(0);
  function getData() {
    axios
      .get(Baseurl.baseurl + "/go-ui/get-cashback")
      .then((res) => {
        setSpinner(false);
        setAllCashBack(res.data.cashBack);
        setSearchData(res.data.cashBack);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  const chageData = (frist, sec) => {
    for (var i = 0; i < data.length; ++i) {
      if (i >= frist && i < sec) {
        data[i].classList.remove("d-none");
      } else {
        data[i].classList.add("d-none");
      }
    }
  };
  activePag.current === 0 && chageData(0, sort);
  let paggination = Array(Math.ceil(data.length / sort))
    .fill()
    .map((_, i) => i + 1);
  const onClick = (i) => {
    activePag.current = i;
    chageData(activePag.current * sort, (activePag.current + 1) * sort);
    settest(i);
  };

  useEffect(() => {
    getData();
   
  }, []);



  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );


//   function searchRider(value) {
//     let filteredData = [];
//     if (searchData) {
//       searchData.map((val) => {
//         let phoneString = val.riderPhone.toString();
//         if (
//           val.riderFirstName.toLowerCase().includes(value) ||
//           val.riderLastName.toLowerCase().includes(value) ||
//           val.riderEmail.toLowerCase().includes(value) ||
//           phoneString.includes(value)
//         ) {
//           filteredData.push(val);
//         }
//       });
//       setRiders(filteredData);
//     }
//   }
  

  function addCashBack(e) {
    e.preventDefault();
    var items = {
      heading: heading,
      amount: amount,
      orderLimit: orderLimit,
      userOrderLimit: userOrderLimit,
    };
    axios
      .post(Baseurl.baseurl + `/go-ui/add-cashback`, items)
      .then((response) => {
        if (response.data.status) {
          swal("Added", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow(false);
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function updateCashBack(e) {
    e.preventDefault();
    var items = {
      amount: amount,
      orderLimit: orderLimit,
      userOrderLimit: userOrderLimit,
    };
    axios
      .put(Baseurl.baseurl + `/go-ui/update-cashback/${cashBackId}`, items)
      .then((response) => {
        if (response.data.status) {
          swal("Updated", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
        setShow(false);
        getData();
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
  }
  function deleteCashBack(){
    axios
      .delete(Baseurl.baseurl + `/go-ui/delete-cashback/${cashBackId}`)
      .then((response) => {
        if (response.data.status) {
          swal("Deleted", response.data.message, "success", {
            button: "Done",
            timer: 1000,
          });

          getData();
        } else {
          swal("Oops", response.data.message, "error", {
            button: "Done",
            timer: 1000,
          });
        }
      })
      .catch((err) => {
        if (err.toString() === "Error: Network Error") {
          history.push("/offline");
        } else {
          history.push("/400");
        }
      });
    setShow1(false);
  }
  return (
    <Col lg={12}>
      <Modal
        size="lg"
        show={show1}
        onHide={() => {
          setShow1(false);
        }}
      >
        <Modal.Body className="text-center"><h4>Are You Sure !! you want to delete cashback</h4></Modal.Body>
        <Modal.Footer>
            <button onClick={()=>{deleteCashBack()}} className="btn btn-danger">Delete</button>
        </Modal.Footer>
      </Modal>
      <Modal show={show} onHide={handleClose}>
        <Modal.Body>
          <form>
            {!updateStatus && (
              <div className=" mb-3">
                <label>Heading</label>
                <input
                  value={heading}
                  type="text"
                  className="form-control"
                  placeholder="enter heading"
                  onChange={(e) => {
                    setHeading(e.target.value);
                  }}
                  required
                />
              </div>
            )}

            <div className=" mb-3">
              <label>Amount</label>
              <input
                value={amount}
                type="number"
                className="form-control"
                placeholder="enter amount"
                onChange={(e) => {
                  setAmount(e.target.value);
                }}
                required
              />
            </div>
            <div className=" mb-3">
              <label>Order Limit</label>
              <input
                value={orderLimit}
                type="number"
                className="form-control"
                placeholder="enter order limit"
                onChange={(e) => {
                  setOrderLimit(e.target.value);
                }}
                required
              />
            </div>
            <div className=" mb-3">
              <label>User Order Limit</label>
              <input
                value={userOrderLimit}
                type="number"
                className="form-control"
                placeholder="enter user order limit"
                onChange={(e) => {
                  setUserOrderLimit(e.target.value);
                }}
                required
              />
            </div>
            <div className="col-sm-3 mt-3">
              <button
                onClick={(e) => {
                  if (updateStatus) {
                    updateCashBack(e);
                  } else {
                    addCashBack(e);
                  }
                }}
                className="btn btn-primary mt-2"
              >
                {updateStatus ? "Update" : "Add"}
              </button>
            </div>
          </form>
        </Modal.Body>
        <Modal.Footer></Modal.Footer>
      </Modal>

      <Card
        style={{
          color: "white",
          background:
            "linear-gradient(90deg, #135334 0%, #98e7c1 100%)",
        }}
      >
        <Card.Header>
          <div>
            {/* <input
              type="text"
              className="form-control"
              placeholder="Search here..."
              onChange={(e) => {
                searchRider(e.target.value);
              }}
            /> */}
          </div>
          <button
            onClick={() => {
              setShow(true);
              setAmount("");
              setOrderLimit("");
              setUserOrderLimit("");
              setUpdateStatus(false);
              setHeading("")
            }}
            className="btn btn-primary"
          >
            Add CashBack
          </button>
        </Card.Header>
        <Card.Body>
          <div id="job_data" className="dataTables_wrapper ">
            {spinner ? (
              <div className="text-center">
                <Spinner animation="border" variant="primary" />
              </div>
            ) : (
              <Table className="text-white text-center" responsive>
                <thead>
                  <tr>
                    <th>
                      <strong>SL NO.</strong>
                    </th>
                    <th>
                      <strong>Header</strong>
                    </th>
                    <th>
                      <strong>Amount</strong>
                    </th>
                    <th>
                      <strong>Rider Order Limit</strong>
                    </th>
                    <th>
                      <strong>User Order Limit</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {allCashBack &&
                    allCashBack.map((cash, key) => (
                      <tr key={cash._id}>
                        <td>{key + 1}</td>
                        <td>{cash.Heading}</td>
                        <td>{cash.CashBackAmount}</td>
                        <td>{cash.OrderLimit}</td>
                        <td>{cash.UserOrderLimit}</td>
                        <td>
                          <Dropdown>
                            <Dropdown.Toggle
                              variant="warning"
                              className="light sharp i-false"
                            >
                              {svg1}
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              <Dropdown.Item
                                onClick={() => {
                                  setShow(true);
                                  setAmount(cash.CashBackAmount);
                                  setOrderLimit(cash.OrderLimit);
                                  setUserOrderLimit(cash.UserOrderLimit);
                                  setUpdateStatus(true);
                                  setCashBackId(cash._id);
                                }}
                              >
                                Update
                              </Dropdown.Item>
                              <Dropdown.Item
                                onClick={() => {
                                  setShow1(true);
                                  setCashBackId(cash._id);
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            </Dropdown.Menu>
                          </Dropdown>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            )}

            {!allCashBack && (
              <Alert
                variant="success"
                className="alert-dismissible fade show text-center"
              >
                Zero CashBack
              </Alert>
            )}
            <div className="d-sm-flex text-center justify-content-between align-items-center mt-3">
              <div className="dataTables_info text-white">
                Showing {activePag.current * sort + 1} to{" "}
                {data.length > (activePag.current + 1) * sort
                  ? (activePag.current + 1) * sort
                  : data.length}{" "}
                of {data.length} entries
              </div>
              <div
                className="dataTables_paginate paging_simple_numbers"
                id="example5_paginate"
              >
                <Link
                  className="paginate_button previous disabled"
                  onClick={() =>
                    activePag.current > 0 && onClick(activePag.current - 1)
                  }
                >
                  Previous
                </Link>
                <span>
                  {paggination.map((number, i) => (
                    <Link
                      key={i}
                      className={`paginate_button  ${
                        activePag.current === i ? "current" : ""
                      } `}
                      onClick={() => onClick(i)}
                    >
                      {number}
                    </Link>
                  ))}
                </span>
                <Link
                  className="paginate_button next"
                  onClick={() => {
                    activePag.current + 1 < paggination.length &&
                      onClick(activePag.current + 1);
                  }}
                >
                  Next
                </Link>
              </div>
            </div>
          </div>
        </Card.Body>
      </Card>
    </Col>
  );
}

export default Cashback;
